// Module
var code = "<p>Post your hosted survey link to your webpage, blog, newsletter or social media and start engaging with your visitors now.</p> ";
// Exports
module.exports = code;